import http from '@/utils/http';

export default {
	list: data => {
		return http({ url: '/api/admin/v1/customer/list', data }).then(r => r);
	},
	detail: data => {
		return http({ url: '/api/admin/v1/customer/detail', data }).then(r => r);
	},
	create: data => {
		return http({ url: '/api/admin/v1/customer/create', data, tip: true }).then(r => r);
	},
	update: data => {
		return http({ url: '/api/admin/v1/customer/update', data, tip: true }).then(r => r);
	},
	delete: data => {
		return http({ url: '/api/admin/v1/customer/delete', data, tip: true }).then(r => r);
	},

	// 地址
	addressList: data => {
		return http({ url: '/api/admin/v1/customer/addressList', data }).then(r => r);
	},
	addressCreate: data => {
		return http({ url: '/api/admin/v1/customer/addressCreate', data, tip: true }).then(r => r);
	},
	addressUpdate: data => {
		return http({ url: '/api/admin/v1/customer/addressUpdate', data, tip: true }).then(r => r);
	},
	addressDelete: data => {
		return http({ url: '/api/admin/v1/customer/addressDelete', data, tip: true }).then(r => r);
	},
	addressGeocode: data => {
		return http({ url: '/api/admin/v1/customer/addressGeocode', data }).then(r => r);
	},
	addressReverseGeocode: data => {
		return http({ url: '/api/admin/v1/customer/addressReverseGeocode', data }).then(r => r);
	},
	matchAreaByLocation: data => {
		return http({ url: '/api/admin/v1/customer/matchAreaByLocation', data }).then(r => r);
	},
};
